"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalRegionsResponseSchema = exports.LocalRegionsQueryParamsSchema = void 0;
var zod_1 = require("zod");
/** [V1] 국내숙소 지역 상권(region) 리스트 조회 - query params */
exports.LocalRegionsQueryParamsSchema = zod_1.z.object({
    type: zod_1.z.union([zod_1.z.literal('MOTEL'), zod_1.z.literal('HOTEL'), zod_1.z.literal('PENSION'), zod_1.z.literal('GUESTHOUSE')]),
});
var LocalRegionItemSchema = zod_1.z.object({
    code: zod_1.z.string(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    items: zod_1.z.array(zod_1.z.object({
        code: zod_1.z.string().nullish(),
        title: zod_1.z.string().nullish(),
        subTitle: zod_1.z.string().nullish(),
        isTopAdvertise: zod_1.z.boolean().nullish(),
        action: zod_1.z
            .object({
            web: zod_1.z.string(),
            app: zod_1.z.string(),
        })
            .nullish(),
        items: zod_1.z.array(zod_1.z.object({
            code: zod_1.z.string(),
            title: zod_1.z.string(),
            action: zod_1.z
                .object({
                web: zod_1.z.string(),
                app: zod_1.z.string(),
            })
                .nullish(),
            serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
            items: zod_1.z.array(zod_1.z.unknown()).nullish(),
        })),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    })),
});
/** [V1] 국내숙소 지역 상권(region) 리스트 조회 - response */
exports.LocalRegionsResponseSchema = zod_1.z.object({
    items: zod_1.z.array(LocalRegionItemSchema),
});
